import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  background-color: #cce6ee;
  padding: 17px 15px;
  width: 397px;
  color: #0384ac;
  font-size: 14px;
  display: flex;
  align-items: center;

  svg {
    margin-right: 10px;
  }
`;
